function initAccordions() {
    const accordions = document.querySelectorAll('.accordion');

    accordions.forEach(accordion => {
        const accordionBtns = accordion.querySelectorAll('.accordion-button');
        const itemContent = accordion.querySelectorAll('.accordion-item-content');

        accordionBtns.forEach(btn => {
            btn.addEventListener('click', () => {
                const accordionItem = btn.closest('.accordion-item');
                accordionItem.classList.toggle('active');

                /* accordionBtns.forEach(otherBtn => {
                    if (otherBtn !== btn) {
                        otherBtn.closest('.accordion-item').classList.remove('active');
                    }
                }); */
            });
        });

        itemContent.forEach(content => {
            content.style.setProperty('--scrollheight', content.scrollHeight + 'px');
        });

    });
}

export default initAccordions;